import { useIntParams } from "core/model/utils/urls";
import { Patient } from "core/types";
import { doctorDashboardRedirectPath } from "entries/sender/Router";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";

type ConsultationLayoutParentContext = {
  clinicalConsultations: { id: number }[];
  patient: Patient;
};

export type ConsultationOutletContext = {
  consultation: { id: number };
  patient: Patient;
};

export function useConsultationContext() {
  const context = useOutletContext<ConsultationOutletContext>();
  if (!context?.consultation) {
    throw new Error(
      "useConsultationContext must be used within a ConsultationLayout",
    );
  }
  return context;
}

export default function ConsultationLayout() {
  const context = useOutletContext<ConsultationLayoutParentContext>();
  const { consultationId } = useIntParams<{ consultationId: number }>();
  const consultation = context?.clinicalConsultations?.find(
    (c) => c.id === consultationId,
  );

  if (consultation == null) {
    return <Navigate replace to={doctorDashboardRedirectPath} />;
  }

  return (
    <Outlet
      context={{
        ...context,
        consultation,
      }}
    />
  );
}
